'use client'

import { Cell, Divider, Label, Spacer, Icon } from '@vinted/web-ui'
import { Flag24 } from '@vinted/monochrome-icons'

import { generateFaqLink } from '@marketplace-web/help-center/help-center-faq-entry-url-data'
import { useBrowserNavigation } from '@marketplace-web/browser/browser-navigation-util'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { SeparatedList } from '@marketplace-web/common-components/separated-list-ui'
import useHelpCenterSessionTracking from '@marketplace-web/help-center/help-center-session-tracking-util'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import {
  userClickRecommendedTopicEvent,
  HelpCenterQuestionModel,
} from '@marketplace-web/help-center/help-center-faq-entry-data'

type RecommendedFaq = {
  id: number
  title: string
  path: string
}

type Props = {
  faqEntries: Array<HelpCenterQuestionModel>
}

const HelpCenterRecommendedFaqList = ({ faqEntries }: Props) => {
  const { access_channel, thread_id } = useBrowserNavigation().searchParams
  const translate = useTranslate('help_center.recommended_faq_list')

  const { track } = useTracking()
  const { helpCenterSessionId } = useHelpCenterSessionTracking()

  const renderFaqItem = ({ id, title }: RecommendedFaq) => (
    <Cell
      key={id}
      prefix={<Icon name={Flag24} color={Icon.Color.GreyscaleLevel3} />}
      title={title}
      type={Cell.Type.Navigating}
      url={generateFaqLink({ id, title }, access_channel, thread_id)}
      chevron
      testId={`help-center-recommended-faq-${id}`}
      onClick={() => track(userClickRecommendedTopicEvent({ helpCenterSessionId }))}
    />
  )

  return (
    <Cell styling={Cell.Styling.Tight}>
      <Label type={Label.Type.Stacked} text={translate('title')} />
      <Spacer size={Spacer.Size.Regular} />
      <SeparatedList separator={<Divider />}>{faqEntries.map(renderFaqItem)}</SeparatedList>
    </Cell>
  )
}

export default HelpCenterRecommendedFaqList
